import React, { useEffect } from 'react';
import Layout from '../components/layout';
import './Appereance.css';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';


function Appearance() {
  // const shopname = "suraj-dev001.myshopify.com"
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code') || sessionStorage.getItem("code");
  if (code) {
    sessionStorage.setItem("code", code)
  }
  const decoded = jwtDecode(code)
  const shopname = decoded.jwttoken
  console.log(shopname)

  // const [dataForApi, setdataForApi] = useState()
  const [primaryColor, setprimaryColor] = useState()
  const [secondaryColor, setsecondaryColor] = useState()
  const [buttonText, setbuttonText] = useState()
  const [buttonBackground, setbuttonBackground] = useState()
  const [border, setborder] = useState()
  const [fontSize, setfontSize] = useState()
  const [textColor, settextColor] = useState('#FF0000')
  const [starColor, setstarColor] = useState()
  const [emptyStar, setemptyStar] = useState()
  const [shopName, setshopName] = useState()
  

  // function for default setting
  const handleDefaultSetting = async () => {
    try {

      const config = await axios.post("https://productreview.ens.enterprises/settings/userSetingDataGet", {

        shopName: shopname
      })
      console.log(config.data.data)
      setbuttonText(config.data.data[0].buttonText)
      setfontSize(config.data.data[0].fontSize)
      settextColor(config.data.data[0].textColor)
      setborder(config.data.data[0].border)
      setstarColor(config.data.data[0].starColor)
      setsecondaryColor(config.data.data[0].secondaryColor)
      setprimaryColor(config.data.data[0].primaryColor)
      setbuttonBackground(config.data.data[0].buttonBackground)
      setemptyStar(config.data.data[0].emptyStar)
      // setDataForApi(config.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  // function for post data
  const handleupdatesetting = async () => {
    // console.log(typeof dataForApi)
    try {
      const config = await axios.post("https://productreview.ens.enterprises/settings/userSettingAddUpdate", {
        shopName: shopname,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        buttonText: buttonText,
        textColor: textColor,
        starColor: starColor,
        emptyStar: emptyStar,
        buttonBackground: buttonBackground,
        border: border,
        fontSize: fontSize
      })
      console.log(config.status)
      if (config.status === 200) {
        toast("Updated Successfully..!")
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    handleDefaultSetting()
  }, []) 
  var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
  (function () {
      var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/60b07e5a6699c7280da95c20/1f6omr56c';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
  })();
  return (
   
      <div style={{ background: "#f6f6f7" }} className=' container'>


        <div className='d-flex justify-content-around resp_container mt-4'>

          <div className=' mb-5 shadow p-3 bg-white rounded control_container'>
            <div style={{ background: "white" }} >
              <p className=' fw-semibold' id='color_head' style={{ fontSize: "11px" }}>Colors</p>
              <div className='d-flex controler'>
                <div className='d-flex color_picker'>
                  <div
                    style={{
                      width: '30px',
                      height: '28px',
                      overflow: 'hidden',
                      borderRadius: '50%',
                      position: 'relative',
                    }}

                  >
                    <input
                      type="color"
                      value={primaryColor}
                      name='primaryColor'
                      style={{
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        border: "0"
                      }}
                      onChange={(e) => { setprimaryColor(e.target.value) }}
                    />
                  </div>

                  <span className='ms-1'>Primary</span>
                </div>

                <div className='d-flex color_picker'>
                  <div
                    style={{
                      width: '30px',
                      height: '28px',
                      overflow: 'hidden',
                      borderRadius: '50%',
                      position: 'relative',
                    }}
                  >
                    <input
                      type="color"
                      value={secondaryColor}
                      name='secondaryColor'
                      style={{
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        border: "0"
                      }}
                      onChange={(e) => { setsecondaryColor(e.target.value) }}
                    />
                  </div>
                  <span className='ms-1'>Secondary</span>
                </div>
              </div>
              <hr />
              <div className=' ' id='btn_container'>
                <p className=' mt-2 fw-semibold' id='btn_head' style={{ fontSize: "11px" }}>Button background Colors</p>
                <div className='d-flex  button_color'>
                  <select name="buttonBackground" value={buttonBackground} style={{ width: "48%" }} className='form-select color_picker' onChange={(e) => { setbuttonBackground(e.target.value) }}>
                    <option selected >Background</option>
                    <option value={primaryColor}>Primary</option>
                    <option value={secondaryColor}>Secondary</option>
                  </select>

                  <div className='text_color'>
                    <div className='d-flex color_picker'>
                      <div
                        style={{
                          width: '30px',
                          height: '28px',
                          overflow: 'hidden',
                          borderRadius: '50%',
                          position: 'relative',
                        }}
                      >
                        <input
                          type="color"
                          value={textColor}
                          name='textColor'
                          style={{
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            border: "0"
                          }}
                          onChange={(e) => { settextColor(e.target.value) }}
                        />
                      </div>
                      <span className='ms-1' >Text color</span>
                    </div>
                  </div>
                </div>
              </div>


              <div className='d-flex input_container '>
                <div className='mb-2' id='font_container'>
                  <p className='fw-semibold font_size'>Font Size</p>
                  <div >
                    <input type="number"
                      className='input_field form-gruop form-control'
                      value={fontSize}
                      name='fontSize'
                      style={{ border: "1px solid #dee2e6" }}
                      onChange={(e) => { setfontSize(e.target.value) }}
                    />
                  </div>
                </div>
                <div className=' ' id='btn_text'>
                  <p className='fw-semibold font_size'>Button text</p>

                  <input type="text"
                    name='buttonText'
                    value={buttonText}
                    className='me-1 input_field form-gruop form-control'
                    style={{ border: "1px solid #dee2e6" }}
                    onChange={(e) => { setbuttonText(e.target.value) }}
                  />

                </div>
              </div>

              <div className='ms-1' id='btn_border'>

                <p className='fw-semibold btn-border star_head' style={{ fontSize: "12px" }}>Border</p>
                <select name="border" value={border} className="form-select mb-4 d-inline-block" id='border_select' onChange={(e) => { setborder(e.target.value) }}>
                  <option selected>Solid</option>
                  <option >Dotted</option>
                  <option >Dashed</option>
                  <option >None</option>
                </select>
              </div>

              <hr />

              <div className='star_container'>

                <p className=' mt-2 fw-semibold star_head' style={{ fontSize: "11px" }}>Star Colors</p>
                <select name="starColor" value={starColor} className="form-select mb-4 d-inline-block" id='star_select' onChange={(e) => { setstarColor(e.target.value) }}>
                  <option value="#FFD700" >Gold</option>
                  <option value="#000000">Black</option>
                  <option value={primaryColor}>Primary</option>
                  <option value={secondaryColor}>Secondary</option>
                </select>
              </div>

              <div className='star_container'>

                <p className='mt-2 fw-semibold star_head' style={{ fontSize: "11px" }}>Empty Star Colors</p>
                <select name="emptyStar" value={emptyStar} className="form-select mb-4 d-inline-block" id='select_div' onChange={(e) => { setemptyStar(e.target.value) }} >
                  <option value="#FFD700">Gold</option>
                  <option value="#000000">Black</option>
                  <option value="#FFFFFF" selected>White</option>
                  <option value={primaryColor}>Primary</option>
                  <option value={secondaryColor}>Secondary</option>
                </select>
              </div>
            </div>

            <div className='justify-content-center d-flex'>
              <button className='btn btn button_bg_css' onClick={handleupdatesetting}>
                Save Changes

              </button>
              <ToastContainer />
            </div>


          </div>

          <div className='shadow p-3 bg-white rounded m-5' style={{ border: "2px dashed #D3D3D3", height: "max-content", width: "-webkit-fill-available" }}>

            <div className='d-flex flex-column justify-content-center align-items-center '>
              {/* <p className='fw-bold fs-3 mt-4 mb-1' style={{ color: `${dataForApi.textColor}` }}>5.0</p> */}

              <div className='mb-2'>

                <span >
                  <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ fill: starColor }} >
                    <path d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z" stroke="#1C274C" stroke-width="1.5" />
                  </svg>
                </span>

                <span >
                  <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ fill: starColor }} >
                    <path d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z" stroke="#1C274C" stroke-width="1.5" />
                  </svg>
                </span>

                <span>
                  <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ fill: starColor }} >
                    <path d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z" stroke="#1C274C" stroke-width="1.5" />
                  </svg>
                </span>

                <span >
                  <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ fill: starColor }}>
                    <path d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z" stroke="#1C274C" stroke-width="1.5" />
                  </svg>
                </span>

                <span >
                  <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ fill: emptyStar }}>
                    <path d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z" stroke="#1C274C" stroke-width="1.5" />
                  </svg>
                </span>

              </div>

              {/* <p className=' fw-semibold' style={{ color: textColor}}>Based on 76 reviews</p> */}
             
              <br></br>
              <button className='fw-semibold button-preview mb-5'
                style={{
                  borderStyle: border,
                  fontSize: fontSize + 'px', backgroundColor: buttonBackground,
                  color: textColor
                }}
              >
                {buttonText}
              </button>
            </div>
          </div>

        </div>
      </div>
    
  )
}

export default Appearance;